<template>
  <div>
    <div
      v-if="collectionResults && collectionResults.length"
      class="is-flex is-flex-direction-column"
    >
      <h3 class="has-text-weight-bold mb-3">
        {{ $t('similarJob') }}
      </h3>
      <div
        v-for="(job, index) in collectionResults || []"
        :key="`job-slab${index}`"
        class="outline is-flex mb-3 px-2 py-2 d-placeitem rounded-10"
      >
        <img
          class="image is-64x64 outline rounded-10 is-paddingless"
          :src="get(job, 'organization.logo')"
        />
        <div class="column py-0">
          <div
            class="pointer is-size-7 has-text-weight-bold"
            @click="openJobDetail(job.slug)"
            v-text="job.job_title"
          ></div>
          <p class="is-size-7" v-text="get(job, 'organization.name')"></p>
          <p class="is-size-7">
            {{ job.job_locations.map(l => l.address).toString() }}
          </p>
        </div>
      </div>
    </div>
    <div v-else class="column">
      <div>
        <vue-no-data :loading="loading" :text="text"></vue-no-data>
      </div>
    </div>
  </div>
</template>

<script>
import VueNoData from '@/components/Commons/VueNoData'
export default {
  components: {
    VueNoData
  },
  props: {
    collectionName: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: 'No data available at the moment'
    },
    showTags: {
      type: Boolean,
      deafult: false
    }
  },
  data() {
    return {
      loading: false,
      endpoint: '',
      initialForm: false,
      nextComponent: '',
      jobApplyForm: {
        jobDetail: {},
        display: false
      }
    }
  },
  computed: {
    collectionResults() {
      return this.get(
        this.$store.state.collection.collectionResponses,
        `${this.collectionName}.results`
      )
    }
  },
  methods: {
    openJobDetail(slug) {
      this.$router.push(
        this.localePath({
          name: 'job-jobSlug-detail',
          params: { jobSlug: slug }
        })
      )
    }
  }
}
</script>
